import { FormTextInput } from '@superhi/design'
import { FieldConfig } from '@superhi/utils'

export const EMAIL: FieldConfig<typeof FormTextInput> = {
  ariaLabel: 'Email',
  name: 'email',
  placeholder: 'Your email address',
}
